import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import isEqual from 'lodash-es/isEqual';
import RegistrationComponent from '@/shared/components/registration/RegistrationComponent';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { createEmptyTimerRegistration, executeAction, isRegistrationValid, getCurrentTime, } from '@/shared/components/registration/registrationHelpers';
import handleHttpError from '@/shared/services/HandleHttpError';
const messages = defineMessages({
    Relation: {
        id: 'Relation',
        defaultMessage: 'Relation',
    },
    CreateTimerRegistration: {
        id: 'CreateTimerRegistration',
        defaultMessage: 'Create timer registration',
    },
});
const registrationOptions = {
    showDate: false,
    showFromUntil: false,
    showDuration: false,
    showQuantity: false,
    showPrice: false,
    showDiscount: false,
    showVat: false,
    showTotalAmount: false,
    showBillable: true,
    showInForfait: true,
    showInternalRemark: true,
    showInvoiceRemark: true,
    showInteraction: false,
};
const CreateTimerRegistrationModal = ({ initialValue = {}, onSave, onClose, show = false, }) => {
    const [registration, setRegistration] = useState(createEmptyTimerRegistration(initialValue));
    const [validationVisible, showValidation] = useState(false);
    const [saving, setSaving] = useState(false);
    const [priceLoading, setPriceLoading] = useState(false);
    const intl = useIntl();
    const save = useCallback(() => {
        setSaving(true);
        const { resource, invoiceStreamId, fromMinutes, plannedTaskId, plannedTaskTemplateId, plannedTaskName, mainPlannedTaskId, mainTaskTemplateId, mainPlannedTaskName, referenceYear, remark, internalRemark, inForfait, isBillable, } = registration;
        const value = {
            resourceId: resource.id,
            invoiceStreamId,
            fromMinutes: fromMinutes || getCurrentTime(),
            plannedTaskId,
            plannedTaskTemplateId,
            plannedTaskName,
            mainPlannedTaskId,
            mainTaskTemplateId,
            mainPlannedTaskName,
            referenceYear,
            remark,
            internalRemark,
            inForfait,
            isBillable,
        };
        Promise.resolve(onSave(value))
            .then(() => {
            setSaving(false);
        }, handleHttpError(intl))
            .finally(() => {
            setSaving(false);
        });
    }, [onSave, registration, intl]);
    const doRegistrationAction = useCallback((action, value) => {
        const newValue = executeAction(registration, action, value);
        if (isEqual(newValue, registration))
            return;
        setRegistration(newValue);
    }, [registration]);
    const isValid = useMemo(() => isRegistrationValid(registration, registrationOptions), [
        registration,
    ]);
    useEffect(() => {
        if (show) {
            showValidation(false);
            setRegistration(createEmptyTimerRegistration(initialValue));
        }
        else {
            setRegistration(null);
        }
    }, [show, initialValue]);
    return (_jsx(OkCancelModal, Object.assign({ title: _jsx("span", { children: _jsx(FormattedMessage, Object.assign({}, messages.CreateTimerRegistration)) }), show: show, onClose: onClose, onSave: save, disabled: saving || priceLoading || (validationVisible && !isValid), onHoverSave: () => showValidation(true) }, { children: _jsx("div", Object.assign({ className: "form-horizontal" }, { children: registration ? (_jsx(RegistrationComponent, { registration: registration, onAction: doRegistrationAction, onPriceLoadingChanged: setPriceLoading, options: registrationOptions, showValidation: validationVisible })) : null })) })));
};
export default CreateTimerRegistrationModal;
